import "./Inputs.scss";
import { useRef } from "react";
import ImagePlaceholder from "../../assets/image_placeholder.png";

const DynamicInput = ({
  label,
  value,
  onChange,
  name,
  type = "text",
  required = false,
  placeholder = "",
  className = "",
  disabled = false,
  min,
  max,
  maxLength,
}) => {
  return (
    <div id="dynamic-input-wrapper" className={`${className}`}>
      {label && (
        <label className="dynamic-input-label" htmlFor={name}>
          {label}
        </label>
      )}
      <input
        className="dynamic-input-field"
        id={name}
        name={name}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        min={min}
        max={max}
        maxLength={maxLength}
      />
      {maxLength && (
        <span className="dynamic-input-counter">
          {(value || "").length}/{maxLength}
        </span>
      )}
    </div>
  );
};

const DynamicTextarea = ({
  label,
  name,
  value,
  onChange,
  onInput,
  rows = 4,
  required = false,
  placeholder = "",
  disabled = false,
  className = "",
  maxLength,
}) => {
  return (
    <div id="dynamic-textarea-wrapper" className={`${className}`}>
      {label && (
        <label className="dynamic-textarea-label" htmlFor={name}>
          {label}
        </label>
      )}
      <textarea
        className="dynamic-textarea-field"
        id={name}
        name={name}
        rows={rows}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        onInput={onInput}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
      {maxLength && (
        <span className="dynamic-textarea-counter">
          {(value || "").length}/{maxLength}
        </span>
      )}
    </div>
  );
};

const DynamicSelect = ({
  label,
  value,
  onChange,
  options,
  placeholder = "Selecione uma opção",
  disabled = false,
  className = "",
}) => {
  return (
    <div id="dynamic-select-wrapper" className={`${className}`}>
      {label && <label className="dynamic-select-label">{label}</label>}
      <select
        className="dynamic-select-field"
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map((opt, idx) => (
          <option key={opt?.value ?? idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const DynamicFileInput = ({
  label,
  name,
  onChange,
  required = false,
  className = "",
  disabled,
}) => {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    //console.log("evento recebido no input:", e);
    onChange(e);
  };

  return (
    <div id="dynamic-file-input-wrapper">
      {label && <label className="dynamic-input-label">{label}</label>}
      <input
        ref={fileInputRef}
        className="dynamic-file-input-wrapper"
        type="file"
        id={name}
        name={name}
        accept="image/*"
        required={required}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
};

const DynamicImagePreview = ({ imageSrc, altText = "Imagem de preview" }) => {
  return (
    <div id="dynamic-image-preview-wrapper">
      <p className="dynamic-input-label">Imagem atual:</p>
      <div className="dynamic-image-preview-container">
        {imageSrc ? (
          <img src={imageSrc} alt={altText} className="dynamic-image-preview" />
        ) : (
          <img src={ImagePlaceholder} alt="Image Placeholder" />
        )}
      </div>
    </div>
  );
};

const DynamicCheckbox = ({
  label,
  name,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div id="dynamic-radio-wrapper">
      <input
        className="dynamic-radio-wrapper-input"
        type="checkbox"
        name={name}
        checked={checked}
        onChange={(e) => onChange(name, e.target.checked)}
        disabled={disabled}
      />
      <label className="dynamic-radio-wrapper-label">{label}</label>
    </div>
  );
};

export {
  DynamicInput,
  DynamicSelect,
  DynamicTextarea,
  DynamicFileInput,
  DynamicImagePreview,
  DynamicCheckbox,
};
